import { ReactNode } from 'react';
import { Box, Stack } from '@mui/material';
import { EmptyState } from 'sections/mcp/mcpUi';

interface FlowOutcomeProps {
  icon: ReactNode;
  title: string;
  body: string;
  actions: ReactNode;
}

/** FlowDialog no-data / error step: the AI Connect empty state plus the way forward. */
const FlowOutcome = ({ icon, title, body, actions }: FlowOutcomeProps) => (
  <Box sx={{ py: 2 }} role="status" aria-live="polite">
    <EmptyState icon={icon} title={title} hint={body} />
    <Stack direction="row" spacing={1} justifyContent="center" sx={{ mt: 1 }}>
      {actions}
    </Stack>
  </Box>
);

export default FlowOutcome;
